<div class="chart-card">
    <h3 class="chart-title">{{ 'pages.collections.analytics.reminder_volume_trend_title' | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart *ngIf="currentData.length > 0" type="line" [data]="chartData" [options]="chartOptions"></canvas>
        <div *ngIf="currentData.length === 0" class="no-data">{{ 'pages.collections.analytics.no_data' | translate }}</div>
    </div>
</div>
